module.exports = __webpack_public_path__ + "static/media/PW.e25d9b3b.png";